import { Container, Stack, Text } from '@mantine/core';
import * as allIcons from '@sloyd/icons';
import classnames from 'classnames';
import { Button } from '../Button/Button';
import SectionTitleCompact from '../SectionTitleCompact/SectionTitleCompact';
import { Actions, Wrapper } from './SectionTitle.style';

export type SectionTitleProps = {
  title: string;
  description?: string;
  children?: React.ReactNode;
  gradient?: any;
  compact?: boolean;
  cta?: string;
  ctaIcon: string;
  onCta?: () => void;
};

export function SectionTitle(props: SectionTitleProps) {
  const {
    title,
    cta,
    ctaIcon = 'IconPlus',
    gradient = { from: 'pink', to: 'white' },
    compact,
  } = props;

  const className = classnames('SectionTitle-wrapper', {
    compact,
  });

  if (compact) {
    return <SectionTitleCompact {...props} />;
  }

  function renderCta() {
    if (!cta) return;

    const IconCmp = (allIcons as any)[ctaIcon];

    return (
      <Actions>
        <Button
          color='pink'
          variant='gradient'
          // @ts-ignore
          gradient={{ ...gradient, deg: 90 }}
          leftSection={<IconCmp />}
          onClick={props.onCta}
        >
          {cta}
        </Button>
      </Actions>
    );
  }

  return (
    <Wrapper className={className} data-testid='SectionTitle-wrapper'>
      <Container size='lg' py='xl' style={{ position: 'relative' }}>
        {renderCta()}
        <Stack align='center'>
          <Text
            component='h2'
            size='3xl'
            fw={800}
            variant='gradient'
            // @ts-ignore
            gradient={{ ...gradient, deg: 90 }}
          >
            {title}
          </Text>
          <Text component='p' size='md' fw={400} c='dimmed'>
            {props.children}
          </Text>
        </Stack>
      </Container>
    </Wrapper>
  );
}

export default SectionTitle;
